import React, {useRef, useState} from "react";
import AppointmentStatusBanner from "./appointment_status_banner";
import ProgendaUtils from "../../progenda_utils";
import HelenaProButton from "../../../admin/components/helena_pro/shared/HelenaProButton";
import {getColor} from "../../colors";
import PI from "../../../services/progenda_interface";
import Config from "../../config";

const AppointmentPopup = ({ backTo, backToSearchView, appointment, calendar, history, updateEventPopupOpened, currentStatus, onClose }) => {
    const popupRef = useRef(null);
    const useHelenaProDesign = Config.get().useHelenaProDesign
    const [newCurrentStatus, setCurrentStatus] = useState(currentStatus);
    const [startFormated, setStartFormated] = useState(ProgendaUtils.dateFormat(appointment.start, "simple_time_format"));
    const [stopFormated, setStopFormated] = useState(ProgendaUtils.dateFormat(appointment.stop, "simple_time_format"));
    const [dateAppointment, setDateAppointment] = useState(ProgendaUtils.dateFormat(appointment.start,"medium_date_format"));

    const appointmentLogo = () =>{
        if (appointment.atHome) {
            return 'fa fa-home'
        }
        else if(appointment.teleconsultation){
            return 'fa fa-video'
        }else{
            return 'fa fa-hospital'
        }
    }

    const hidePopup = () => {
        if(onClose){
            //modal mode
            onClose()
        }
        else if(popupRef.current && popupRef.current.parentElement) {
            //popup mode in fullcalendar view and helena pro design
            popupRef.current.parentElement.style.display = "none";
            updateEventPopupOpened && updateEventPopupOpened(null);
        }
    }

    const editAppointment = () =>{
        history.push(PI.adminCalendarAppointmentPath(
            calendar.slug,
            appointment.id,
            {back_to: backTo, back_to_search_view: backToSearchView ? 'true' : null},
        ));
    }

    const colorGray900 =  getColor('defaultPopupLabel', true)
    const labelBorderColor = appointment.color === '' || appointment.color === '#FFFFFF' ? colorGray900 : appointment.color;
    const labelColor = appointment.color === '' || appointment.color === '#FFFFFF' ? colorGray900 : '';

    return (
        <div ref={popupRef} className="appointment-popup">
            <div className='arrow'></div>
            <div className='popup-header'>
                <i className="fa fa-sharp fa-solid fa-quote-left"></i>
                <i className="fa fa-expand-alt" onClick={editAppointment}></i>
                <span className="appointment-title">{appointment.title}</span>

                <div className="popup-labels">
                    {newCurrentStatus === 'no_show' &&
                        <div className="popup-label no_show-bg-color">
                            <span className='popup-label-logo'><i className='fas fa-eye-slash'/></span>
                            <span className='popup-label-text'>{I18n.get().t('no_show')}</span>
                        </div>
                    }
                    <div className="popup-label" style={{
                        backgroundColor: appointment.color,
                        borderColor: labelBorderColor,
                        color: labelColor,
                    }}>
                        <span className='popup-label-logo'><i className={appointmentLogo()}/></span>
                        {appointment.serviceName && <span className='popup-label-text'>{appointment.serviceName}</span>}
                    </div>
                </div>

            </div>
            {!onClose && useHelenaProDesign &&
                //onClose is only comming from modal
                // we don't want to see the status banner in this case and in the case we are in progenda mode
                <>
                    <hr/>
                    <AppointmentStatusBanner
                        appointment={appointment}
                        calendar={calendar}
                        currentStatus={newCurrentStatus}
                        onCurrentStatusUpdate={setCurrentStatus}
                    />
                </>
             }
            <hr/>
            <div className="data-rows">
            <div className="data-row">
                    <i className="fa fa-calendar"></i>
                    <span className="data-text appointment-date">{dateAppointment}</span>
                </div>

                <div className="data-row">
                    <i className="fas fa-clock"></i>
                    <span className='data-text start-stop-date'>{startFormated} - {stopFormated}</span>
                </div>

                <div className="data-row">
                    <i className="far fa-user"></i>
                    <span className="data-text appointment-patient">{appointment.patientFullName}</span>
                </div>

                <div className="data-row">
                    <i className="fas fa-user-md"></i>
                    <span className="data-text appointment-doctor">{calendar.officialName}</span>
                </div>
                {appointment.atHome &&
                    <div className="data-row">
                        <i className="far fa-map"></i>
                        <span className="data-text appointment-address">{appointment.address}</span>
                    </div>
                }
                {appointment.notes &&
                    <div className="data-row">
                        <i className="fas fa-sticky-note"></i>
                        <span className="data-text appointment-note">{appointment.notes}</span>
                    </div>
                }
            </div>
            <hr/>
            <div className='appointment-popup-buttons flex'>
                {useHelenaProDesign ?
                    <>
                        <HelenaProButton label={I18n.get().t('close')} onClick={hidePopup}/>
                        <HelenaProButton label={I18n.get().t('edit')} buttonType="primary" onClick={editAppointment}/>
                    </>
                :
                    <>
                        <button type="button" className="btn btn-sm btn-default" onClick={hidePopup}>{I18n.get().t("close")}</button>
                        <button type="button" className="btn btn-sm btn-primary" onClick={editAppointment}>{I18n.get().t("edit")}</button>
                    </>
                }

            </div>
        </div>
    )
}
export default AppointmentPopup;